/** Up to two letters for the carrier letter-avatar (no carrier logos): one per word, or the first
 * two characters of a single-word name. */
export function carrierInitials(name: string): string {
  const words = name.split(/\s+/).filter((word) => /[a-z0-9]/i.test(word));
  const source =
    words.length === 1 ? (words[0] ?? '') : words.map((word) => word[0] ?? '').join('');
  return source.slice(0, 2).toUpperCase() || '?';
}
